import { IDocumentCoding } from './IDocumentCoding'
import { fileExtFromMimeType } from "../../../lib/FileUtils";
import { getQueryString } from "../../../lib/QueryString";
import { DocumentRetrieveStatus } from "./DocumentRetrieveStatus";

export interface IDocumentListItem {
    description?: string,
    contentType?: string,
    url?: string,

    type?: IDocumentCoding,
    category?: IDocumentCoding,

    source?: string,

    author?: string,
    startTimestampUTC?: Date
    endTimestampUTC?: Date,
    retrieveStatus?: DocumentRetrieveStatus
}

// Give a document, determine if it indicates it is a CCD
export function isCCDDocument(doc?: IDocumentListItem): boolean
{
    if (!doc)
        return false;

    return ("xml" === fileExtFromMimeType(doc.contentType)?.toLowerCase());
}

// Get any import status messages
export function getImportErrorMsg(doc:IDocumentListItem): string|undefined
{
    if (undefined == doc.retrieveStatus)
        return;

    switch(doc.retrieveStatus)
    {
        case DocumentRetrieveStatus.Importing: 
        return "This document is being imported";

        case DocumentRetrieveStatus.Imported: 
        return "This document has already been imported";

        case DocumentRetrieveStatus.Retrieving: 
        return "This document is being retrieved";
    }
}

export function documentTitle(doc?: IDocumentListItem)
{
    return doc?.description ?? docFileNameWithoutExtension(doc) ?? "n/a";
}

export function docFileNameWithoutExtension(doc?: IDocumentListItem, fileExt?: string): string|undefined
{
    if (!doc)
        return;

    // Use the file description is available
    if (doc.description)
        return doc.description;

    // Create a file name from the document ID
    let filename = getQueryString("documentId", new URLSearchParams(new URL("https://www.FakeDomainToMakeJsHappy.com"+doc.url).search));

    if (fileExt)
    {
        if (filename?.toLowerCase().endsWith(fileExt.toLowerCase()))
        {
            filename = filename.slice(0, -fileExt.length);
            if (filename.slice(fileExt.length).endsWith("."))
                filename = filename.slice(0, -1);
        }
    }
    return filename;
}